module.exports = __webpack_public_path__ + "img/main-bolbs-screen.eac9cfab.png";